import React, { useCallback, useEffect, useRef, useState } from "react";

import { Helmet } from "react-helmet-async";
import {
  AudioLines,
  Printer,
  Bookmark,
  Share2,
  Home,
  Volume2,
  Download,
  VolumeOff,
  Eye,
  ThumbsUp,
  Pencil
} from "lucide-react";
import omimage from "../assets/images/omimage.png";
import aboutimg from "../assets/images/aboutimg.jpg";
import homebanner from "../assets/images/aboutbanner.jpg";
import storiesimg from "../assets/images/storiesimg.jpg";

import { apiUrl, assetsUrl } from "../config/Config";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "react-activity/dist/Spinner";
import html2pdf from "html2pdf.js";
import { Button, Modal } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from 'react-redux';
import SharePopup from "../components/SharePopup";
import new_defaultimg from '../assets/images/new_omsaga_default.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus, faDownload } from "@fortawesome/free-solid-svg-icons";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const StoryViewPage = () => {
  const { slug } = useParams();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [storydetails, setstorydetails] = useState({});
  const [showpageloading, setshowpageloading] = useState(false);
  const [imagesarr, setimagesarr] = useState([]);
  const [showmodal, setshowmodal] = useState(false);
  const storydetailsRef = useRef();
  storydetailsRef.current = storydetails;

  const [showaudiocontrol, setshowaudiocontrol] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [relatedstories, setrelatedstories] = useState([]);

  const [playing, setPlaying] = useState(false);
  const [showShare, setShowShare] = useState(false);

  const pdfRef = useRef();

  const audioRef = useRef(null);

  const contentRef = useRef(null);

  const customerdata = useSelector((store) => store.userReducer.customerdata);

  const showRegistrationRequired = useCallback(() => {
    Swal.fire({
      title: "Registration Required",
      text: "Please register or log in to read the full story.",
      icon: "info",
      iconColor: "#d65300",
      confirmButtonText: "OK",
      confirmButtonColor: "#d65300",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/register", { replace: true });
      }
    });
  }, [navigate]);

  const reactToPrintFn = useReactToPrint({ contentRef, documentTitle: '' });

  const generatePDF = (name) => {
    const element = contentRef.current;
    const options = {
      margin: 0.5,
      filename: name+".pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
    };
    html2pdf().set(options).from(element).save();
  };

  const handleLike = async() => {
    setstorydetails({
      ...storydetails,
      liked: (parseInt(storydetails?.liked) || 0) + 1
    });
    // Update database
    var data = {
      id: storydetails?.id,
      liked: (parseInt(storydetails?.liked) || 0) + 1
    };
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
      .post(apiUrl + "updatelike", data, headers)
      .then((res) => {
        if (res.data.status == "success") {}
          
      })
      .catch((err) => {
        console.log("err >>", err);
        setshowpageloading(false);
      });
  };

  const formatDate = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    }
  const CKEditorOutput = ({ content }) => {
    return (
      <div
        dangerouslySetInnerHTML={{ __html: content }}
      />
    );
  }

  const fetchstorydetails = useCallback(async (slugtitle) => {
    setshowpageloading(true);
    var data = {
      slug: slugtitle,
    };
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + customerdata.token,
      },
    };
    let resp = await axios
      .post(apiUrl + "getstorydetails", data, headers)
      .then((res) => {
        if (res.data.status == "success") {
          var prevdata = res?.data?.data;
          if (Object.keys(prevdata)?.length > 0) {
            setstorydetails(prevdata);
            if(prevdata?.photos) {
              var previmages = JSON.parse(prevdata?.photos);
              setimagesarr(previmages);
            } else {
              setimagesarr([]);
            }
          } else {
            setstorydetails({});
            setimagesarr([]);
          }

          var prevrelateddata = res?.data?.relatesstories;
          if(prevrelateddata?.length > 0) {
            setrelatedstories(prevrelateddata);
          } else {
            setrelatedstories([]);
          }

          setshowpageloading(false);
        } else {
          setstorydetails({});
          setshowpageloading(false);
        }
        setshowpageloading(false);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          dispatch({ type: "customerdata", payload: {} });
        }
        console.log("err >>", err);
        setshowpageloading(false);
      });
  }, [customerdata.token, dispatch]);

  const downloadaudiofile = async(audiourl, title) => {
    console.log('audiourl >>', audiourl);
    try {
      const response = await fetch(audiourl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = title + ".webm";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading audio file:", error);
    }
  }

  const handleplayaudio = (name) => {
    // var url = '/storage/uploads/audio/'+name;
    var url = assetsUrl + "/audio/" + name
    console.log('url >>', url)
    if (!audioRef.current) {
      audioRef.current = new Audio(url);
    }
    audioRef.current.play();
    setPlaying(true);
  }

  const handleStop = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      setPlaying(false);
    }
  };

  const funcshowstorylisten = () => {
    setshowaudiocontrol(true);
  }

  const ImageSlider  = ({imagesarr}) =>  {
    return (
      <>
        {imagesarr?.length > 0 ? (
          imagesarr?.length > 1 ? (
            <div
              id="storySlider"
              className="carousel slide"
              data-bs-ride="carousel"
              data-bs-wrap="false"
            >
              <div className="carousel-inner">
                {
                  imagesarr?.map((item, index) => {
                    return (
                      <div className={index == 0 ? "carousel-item active" : "carousel-item"}>
                        <img
                          src={assetsUrl + "/photos/" + item}
                          alt="Story"
                          className="img-fluid story-viewpage-main-img"
                        />
                      </div>
                    );
                  })
                }
                
              </div>

              {/* Left Arrow */}
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#storySlider"
                data-bs-slide="prev"
              >
                <span className="carousel-control-prev-icon"></span>
              </button>

              {/* Right Arrow */}
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#storySlider"
                data-bs-slide="next"
              >
                <span className="carousel-control-next-icon"></span>
              </button>
            </div>
          ) : (
            // Single image
            <div className="storySlider">
              <img
              src={assetsUrl + "/photos/" + imagesarr[0]}
              alt="Story"
              className="img-fluid story-viewpage-main-img"
            />
            </div>
            
          )
        ) : null}
      </>
    );
  }

  useEffect(() => {
    if (customerdata?.token) {
      fetchstorydetails(slug);
    } else {
      showRegistrationRequired();
    }
  }, [slug, customerdata?.token, fetchstorydetails, showRegistrationRequired]);

  return (
    <>
      <Helmet>
        <title> Spiritual Story | THEOMSAGA</title>

        <meta
          name="description"
          content={`Read on THEOMSAGA — a spiritual story exploring mindfulness, inner growth, and timeless wisdom.`}
        />

        <link rel="canonical" href={`https://theomsaga.com/stories`} />

        {/* Open Graph */}
        <meta property="og:title" content="THEOMSAGA" />
        <meta
          property="og:description"
          content="A spiritual story exploring inner wisdom and mindfulness."
        />
        <meta property="og:url" content={`https://theomsaga.com/stories`} />
        <meta property="og:type" content="article" />
        <meta property="og:image" content />

        {/* Schema */}
        <script type="application/ld+json">
          {`
    {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "",
      "author": {
        "@type": "Person",
        "name": ""
      },
      "publisher": {
        "@type": "Organization",
        "name": "THEOMSAGA"
      },
      "datePublished": "",
      "articleSection": "Spiritual Stories",
      "image": "",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://theomsaga.com/stories"
      }
    }
    `}
        </script>
      </Helmet>

      {Object.keys(storydetailsRef.current)?.length > 0 ? (
        <div>
          <section className="home-main-section about-bannar-img">
            <div className="container text-center">
              <div className="bannnermaindiv">
                <p className="banner-heading">
                  {storydetailsRef.current?.title}
                </p>
                <Home className="banner-home-icon" />{" "}
                <span className="bannner-subhead">
                  / {storydetailsRef.current?.slug}
                </span>
              </div>
            </div>
          </section>

          <section>
            <div className="container story-viewpage py-5">
              <div className="row mb-4">
                <div className="col-12 col-md-6 col-lg-6 mb-4">
                  <p className="story-viewpage-title">
                    {storydetailsRef.current?.title}
                  </p>

                  <div className="story-viewpage-meta">
                    <span>
                      Author:{" "}
                      {storydetailsRef.current?.hide_author == "true"
                        ? "Devotee"
                        : storydetailsRef.current?.author}
                    </span>
                    {/* <span>Author: {storydetailsRef.current?.author}</span> */}
                    <span>
                      Date: {formatDate(storydetailsRef.current?.created_at)}
                    </span>
                    <span>
                      Language:{" "}
                      {storydetailsRef.current?.language == "en"
                        ? "English"
                        : "Hindi"}
                    </span>
                  </div>
                  <div className="story-page-meta">
                    <span className="story-page-meta-item">
                      <Eye size={18} />
                      {storydetails?.view || 0} Views
                    </span>

                    <span
                      className={`story-page-like ${isLiked ? "active" : ""}`}
                      onClick={handleLike}
                    >
                      <ThumbsUp size={18} />
                      {storydetails?.liked || 0}
                    </span>
                    {console.log(
                      "customerdata storyview page >>",
                      customerdata
                    )}

                    {/* {Object.keys(customerdata)?.length > 0 ? 
                    storydetails?.user == customerdata?.userid ?
                      <span
                        className="story-page-edit"
                        onClick={() =>
                          navigate(`/edit-story/${storydetails?.slug}`)
                        }
                      >
                        <Pencil size={18} />
                        Edit
                      </span> : null
                     : null} */}
                  </div>

                  {storydetailsRef.current?.storytype == "audiobased" &&
                  storydetailsRef.current?.audio ? (
                    <div className="story-viewpage-audio">
                      <button
                        className="story-viewpage-listen-btn"
                        onClick={() => {
                          funcshowstorylisten();
                        }}
                      >
                        <AudioLines className="me-2" size={18} />
                        Listen to this story
                      </button>
                    </div>
                  ) : null}

                  {showaudiocontrol && storydetailsRef.current?.audio ? (
                    <div className="mt-3">
                      <audio
                        controls
                        src={
                          assetsUrl + "audio/" + storydetailsRef.current?.audio
                        }
                      ></audio>
                    </div>
                  ) : null}
                </div>
                <div className="col-12 col-md-6 col-lg-6 mb-4">
                  {/* {imagesarr?.length > 0 ? (
                    <img
                      src={assetsUrl + "/photos/" + imagesarr[0]}
                      alt="Story"
                      className="img-fluid story-viewpage-main-img"
                    />
                  ) : null} */}
                  <ImageSlider imagesarr={imagesarr} />
                </div>
              </div>

              {storydetailsRef.current?.storytype == "audiobased" ? null : (
                <div className="row mb-4">
                  <div className="col-12">
                    <div className="story-viewpage-content">
                      <CKEditorOutput
                        content={storydetailsRef?.current?.storyText}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-5">
                <div className="col-12 text-center story-viewpage-actions ">
                  {storydetailsRef.current?.storytype == "audiobased" ? (
                    storydetailsRef.current?.audio ? (
                      <button
                        className="btn story-viewpage-action-btn download-btn-mobile-view"
                        onClick={() => {
                          downloadaudiofile(
                            assetsUrl +
                              "audio/" +
                              storydetailsRef.current?.audio,
                            storydetailsRef.current?.title
                          );
                        }}
                      >
                        <Download className="me-2" size={18} /> Download This
                        Story
                      </button>
                    ) : null
                  ) : (
                    <button
                      className="btn story-viewpage-action-btn download-btn-mobile-view"
                      onClick={() => {
                        setshowmodal(true);
                      }}
                    >
                      <Printer className="me-2" size={18} /> Print This Story
                    </button>
                  )}

                  {/* <button className="btn story-viewpage-action-btn">
                    <Bookmark className="me-2" size={18} /> Bookmark
                  </button> */}
                  <button
                    className="btn story-viewpage-action-btn"
                    onClick={() => setShowShare(true)}
                  >
                    <Share2 className="me-2" size={18} /> Share
                  </button>
                  {showShare && (
                    <SharePopup onClose={() => setShowShare(false)} />
                  )}
                </div>
              </div>

              {relatedstories?.length > 0 ? (
                <section className="home-stories-main-section">
                  <div className="container  text-center">
                    <img
                      src={omimage}
                      alt="Logo"
                      className="om-image-stories"
                      loading="eager"
                      decoding="async"
                    />
                    <span className="home-subhead">Stories</span>

                    <p className="home-heading">Related Stories</p>
                    <div className="home-heading-divider"></div>

                    <div className="home-stories-mid-section">
                      <div className="row">
                        {relatedstories?.length > 0
                          ? relatedstories?.map((item, index) => {
                              var reloadimg = "";
                              if (item?.photos) {
                                var imagesarr = JSON.parse(item?.photos);
                                if (imagesarr?.length > 0) {
                                  reloadimg = imagesarr[0];
                                }
                              }
                              return (
                                <div className="col-12 col-md-6 col-lg-4 mb-4">
                                  <div className="home-storiesgrid-box">
                                    <img
                                      className="home-stories-box-img"
                                      src={
                                        reloadimg
                                          ? assetsUrl + "/photos/" + reloadimg
                                          : new_defaultimg
                                      }
                                      alt=""
                                    />
                                    <div className="home-stories-box-content">
                                      <p className="home-stories-box-content-tittle">
                                        {item?.title}
                                      </p>
                                      <div className="home-stories-box-content-footer">
                                        <p
                                          className="home-stories-box-content-readmore"
                                          onClick={() => {
                                            navigate("/story/" + item?.slug);
                                          }}
                                        >
                                          Read More
                                        </p>
                                        {item?.audio ? (
                                          <>
                                            {playing ? (
                                              <div
                                                className=""
                                                onClick={() => {
                                                  handleStop(item?.audio);
                                                }}
                                              >
                                                <VolumeOff
                                                  size={20}
                                                  className="home-stories-box-audioicon"
                                                />
                                              </div>
                                            ) : (
                                              <div
                                                className=""
                                                onClick={() => {
                                                  handleplayaudio(item?.audio);
                                                }}
                                              >
                                                <Volume2
                                                  size={20}
                                                  className="home-stories-box-audioicon"
                                                />
                                              </div>
                                            )}
                                          </>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          : null}
                      </div>
                    </div>
                  </div>
                </section>
              ) : null}
            </div>
          </section>
        </div>
      ) : (
        <div className="emptydetailspage">
          <div className="container story-viewpage py-5">
            {showpageloading ? (
              <Spinner color="#FF6600" size={24} className="pagespinner" />
            ) : (
              <h5 style={{ textAlign: "center" }}>No data</h5>
            )}
          </div>
        </div>
      )}

      <Modal
        show={showmodal}
        onHide={() => setshowmodal(false)}
        size="xl"
        className="custom-width-modal storyview-custome-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: 19 }}>Preview</Modal.Title>
          <div style={{ marginLeft: "auto", marginRight: 10, marginTop: 5 }}>
            {/* <button
              className="btn btn-success custombtn"
              onClick={() => {
                reactToPrintFn();
              }}
            >
              Download
            </button> */}
            <FontAwesomeIcon
              icon={faDownload}
              onClick={() => {
                reactToPrintFn();
              }}
              style={{color: '#FF6600', fontSize: 20, cursor: 'pointer'}}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="webadmin-modalmainbody">
            <div
              ref={contentRef}
              style={{ padding: "0px", maxWidth: 800, margin: "auto" }}
            >
              {imagesarr?.length > 0 ? (
                <img
                  src={assetsUrl + "photos/" + imagesarr[0]}
                  alt="Story"
                  style={{ maxHeight: 400, objectFit: "cover", width: "100%" }}
                />
              ) : null}
              <p
                style={{
                  color: "#000",
                  fontSize: 18,
                  marginTop: 20,
                  fontWeight: "600",
                }}
              >
                {storydetailsRef.current?.title}
              </p>
              <div className="story-viewpage-meta">
                <span>
                  Author:{" "}
                  {storydetailsRef.current?.hide_author == "true"
                    ? "Devotee"
                    : storydetailsRef.current?.author}
                </span>

                <span>
                  Date: {formatDate(storydetailsRef.current?.created_at)}
                </span>
                <span>
                  Language:{" "}
                  {storydetailsRef.current?.language == "en"
                    ? "English"
                    : "Hindi"}
                </span>
              </div>
              <div className="story-viewpage-content mt-4">
                <CKEditorOutput content={storydetailsRef?.current?.storyText} />
              </div>
            </div>
            <div style={{ marginTop: 30 }}>
              <button
                className="btn btn-success custombtn"
                onClick={() => {
                  reactToPrintFn();
                }}
              >
                Download Now
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default StoryViewPage;
